import { Injectable } from '@angular/core';
import { HttpService } from './http/http.service';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class RecipientService {

  constructor(private http: HttpClient, private httpService: HttpService) { }

  getRecipientList(companyDetail){
    var request = {
        URL: "dataTable/recipientDetails",
        DATA: companyDetail
    }
    return this.httpService.post(request);
}

addApproveRecipient(newRecipient) {
    var request = {
        URL: "recipient/addApprove/"+newRecipient,
    }
    return this.httpService.get(request);        
}

getAllRecipientList(companyDetail){
    var request = {
        URL: "dataTable/getAllRecipientList",
        DATA: companyDetail
    }
    return this.httpService.post(request);
}
addrecipient(newRecipient:any) {
    var request = {
        URL: "recipient/add",
        DATA: newRecipient
    }
    return this.httpService.post(request).map((res:any)=>{
    
        return (res);
    }).catch((error)=>{
        return error;
    });            
}

removeFileName(recipientId: string) {
    var request = {
        URL: 'recipient/removeFileName/' + recipientId
    }
    return this.httpService.get(request);
}

updateSharer(newSharer){
    var request = {
        URL:  'agenda/edit/'+newSharer._id,
        DATA: newSharer
    }
    return this.httpService.post(request);        
}

editRecipient(recipientId: string) {

    var request = {
        URL: 'recipient/edit/' + recipientId
    }
    return this.httpService.get(request);
}

deleteRecipient(recipientId: string) {
    var request = {
        URL: "recipient/delete/"+recipientId,
      
    }
    return this.httpService.get(request);        
}

CheckUniqeEmailWithInCmp(email_id){
    var request = {
        URL: "recipient/checkUniqueEmail",
        DATA: {email:email_id}
    }
    return this.httpService.post(request);     
}

getRecipientHistory(RecipientId: string) {
    var request = {
        URL: "recipient/history/"+RecipientId,
      
    }
    return this.httpService.get(request);        
}
}
